import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { faBell, faCheck } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import type { ButtonProps } from '@components/main-components/button/Button';
import { Button } from '@components/main-components/button/Button';
import { DataTestId } from '@utils/test';

type UpcomingDropButtonProps = {
  showSubscribed: boolean;
  loading: boolean;
  onClick: ButtonProps['onClick'];
  isOwner: boolean;
};

export const UpcomingDropButton = ({
  showSubscribed,
  loading,
  onClick,
  isOwner,
}: UpcomingDropButtonProps) => {
  return (
    <div className="p-2 pt-0">
      <Button
        testId={DataTestId.GET_NOTIFIED_BUTTON}
        className={clsx(
          'font-title text-title-xs font-medium',
          'focus:border-none focus:outline-none',
          showSubscribed ? 'bg-[transparent] text-white hover:text-black' : 'text-black',
        )}
        fullWidth
        variant="tertiary"
        label={showSubscribed ? 'Subscribed' : 'Get Notified'}
        leadingIcon={<FontAwesomeIcon icon={showSubscribed ? faCheck : faBell} fontSize={20} />}
        loading={loading}
        onClick={onClick}
        disabled={isOwner}
      />
    </div>
  );
};
